import type { BriefSection, Tier1Inputs } from '../../types/canvas';
import { ProgressDots } from './ProgressDots';

interface BriefHeroProps {
  title?: string;
  inputs: Tier1Inputs;
  sections: BriefSection[];
}

const GENRE_LABELS: Record<string, string> = {
  'fantasy': 'Fantasy',
  'historical': 'Historical',
  'horror': 'Horror',
  'literary-speculative': 'Literary Speculative',
  'literary-thriller': 'Literary Thriller',
  'mystery': 'Mystery',
  'romance': 'Romance',
  'romantasy': 'Romantasy',
  'sci-fi': 'Science Fiction',
  'ya': 'Young Adult',
};

export function BriefHero({ title, inputs, sections }: BriefHeroProps) {
  const genreLabel = GENRE_LABELS[inputs.genre] ?? inputs.genre;

  return (
    <div className="max-w-[1080px] mx-auto px-5 sm:px-8 pt-9 sm:pt-10">
      <div className="text-[10px] tracking-[0.14em] uppercase text-placeholder mb-1">
        <span className="text-primary/60" aria-hidden="true">§</span> Working Brief
      </div>
      <h1 className="font-display text-[30px] font-normal italic text-heading mb-1.5 [font-variation-settings:'opsz'_96,'SOFT'_60]">
        {title ?? 'Untitled Brief'}
      </h1>
      <div className="text-xs text-muted-foreground mb-5 flex items-center gap-2 flex-wrap">
        <span className="inline-block py-0.5 px-2.5 rounded-full bg-surface border border-border text-[10px] font-semibold uppercase tracking-[0.05em]">
          {genreLabel}
        </span>
        <span className="inline-block py-0.5 px-2.5 rounded-full bg-surface border border-border text-[10px] font-semibold uppercase tracking-[0.05em]">
          Standalone
        </span>
        <span className="text-placeholder">·</span>
        <span>{sections.length} sections</span>
      </div>
      <ProgressDots sections={sections} />
    </div>
  );
}
